import { defineComponent as h, computed as l, openBlock as a, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const v = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "95bad9e0-f762-4b14-89e6-811c93ce701f" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#95bad9e0-f762-4b14-89e6-811c93ce701f)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#0052b4" d="M0 44.6 255.3 18 512 44.6v194.7L493.7 256l18.3 16.7v194.7l-255.5 27.5L0 467.4V272.7l17.5-17.3L0 239.3z"></path><path fill="#eee" d="m100.2 256.1 155.8-98 155.8 98-155.8 98z"></path><path fill="#6da544" d="M167 300.6h200.3l-44.5-66.8-22.3 22.3-22.2-11-22.3 33.3h-44.5l-22.3-22.3z"></path><path fill="#ffda44" d="m256 189.3 5.5 17h18l-14.6 10.5 5.6 17-14.5-10.5-14.5 10.5 5.6-17-14.5-10.5h17.9z"></path><path fill="#d80027" d="M0 0v44.6h239.4v96l-157 98.7H0v33.4h82l157.3 99v95.7H0V512h512v-44.6H272.7v-95.8L430 272.7h82v-33.4h-82.4l-156.9-98.6v-96H512V0H0zm256 169.6 137.6 86.5L256 342.6l-137.6-86.5L256 169.6z"></path>', 5), g = { fill: "none" }, x = ["r"], y = /* @__PURE__ */ h({
  __name: "bq-se",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), s = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (z, w) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (a(), i("title", k, d(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, v));
  }
});
export {
  y as default
};
//# sourceMappingURL=bq-se-634f0ce8.js.map
